module.exports = __webpack_public_path__ + "img/John Iremil Teodoro.6987c9e8.jpg";